import { SEARCH_TYPES } from '../actions/searchActions';

// Helper functions to handle localStorage
const saveToLocalStorage = (state) => {
  try {
    localStorage.setItem('searchState', JSON.stringify(state));
  } catch (error) {
    console.error('Failed to save state to localStorage:', error);
  }
};

const loadFromLocalStorage = () => {
  try {
    const serializedState = localStorage.getItem('searchState');
    return serializedState ? JSON.parse(serializedState) : undefined;
  } catch (error) {
    console.error('Failed to load state from localStorage:', error);
    return undefined;
  }
};

// Initialize state with persisted data or defaults
const initialState = loadFromLocalStorage() || {
  projectId: [],
  projectName: '',
  partIds: [],
  shortlisted: {
    description: '',
    shortlisted: [],
  },
  searchParams: {},
};

const searchReducer = (state = initialState, action) => {
  let newState;

  switch (action.type) {
    case SEARCH_TYPES.BEGIN_SEARCH:
      newState = {
        ...state,
        ...action.payload,
      };
      break;

    case SEARCH_TYPES.ADD_SHORTLISTED:
      newState = {
        ...state,
        shortlisted: action.payload,
      };
      break;

    case SEARCH_TYPES.SET_SEARCH_RESULT:
      newState = {
        ...state,
        searchParams: action.payload,
      };
      break;

    case SEARCH_TYPES.CLEAR_SEARCH:
      newState = {
        projectId: [],
        projectName: '',
        partIds: [],
        shortlisted: {
          description: '',
          shortlisted: [],
        },
        searchParams: {},
      };
      break;

    default:
      newState = state;
      break;
  }

  saveToLocalStorage(newState);
  return newState;
};

export default searchReducer;
